import { createFetch } from "@better-fetch/fetch";

import type {
	Enquire,
	HomePage,
	Invest,
	Location,
	Lodge,
	Media,
	Membership,
	Menu,
	Page,
	Partnership,
	Post,
	PrivacyPolicy,
	Property,
	RealEstate,
	TermsAndCondition,
	Video,
} from "../types/payload";

export const cms = createFetch({
	baseURL: `https://waimarino-memberships-cms.vercel.app/api`,
});

export const designGroupCms = createFetch({
	baseURL: `https://www.thedesigngroup.co.nz/api`,
});

export const getEnquire = async () => await cms<Enquire>("/globals/enquire?depth=3");

export const getMedia = async () => await cms<Media>("/globals/media?depth=3");

export const getMenu = async () => await cms<Menu>("/globals/menu?depth=3");

export const getPartnerships = async () => await cms<Partnership>("/globals/partnerships?depth=3");

export const getPrivacyPolicy = async () => await cms<PrivacyPolicy>("/globals/privacy-policy?depth=3");

export const getTermsAndConditions = async () => await cms<TermsAndCondition>("/globals/terms-and-conditions?depth=3");

export const getRealEstate = async () => await cms<RealEstate>("/globals/real-estate?depth=3");

export const getMembership = async () => await cms<Membership>("/globals/membership?depth=3");

export const getInvest = async () => await cms<Invest>("/globals/invest?depth=3");

export const getLodge = async () => await cms<Lodge>("/globals/lodge?depth=3");

export const getHomePage = async () => await cms<HomePage>("/globals/home-page?depth=3");

export const getLocation = async () => await cms<Location>("/globals/location?depth=3");

export const getPage = async (slug: string) =>
	await cms<{ docs: [] | [Page] }>(`/pages?depth=3&where[slug][equals]=${slug}&limit=1`);

export const getPages = async () => await cms<{ docs: [] | [Page] }>(`/pages?depth=3&limit=10&sort=-updatedAt`);

export const getProperty = async (slug: string) =>
	await cms<{ docs: [] | [Property] }>(`/properties?depth=3&where[slug][equals]=${slug}&limit=1`);

export const getProperties = async () =>
	await cms<{ docs: [] | [Property] }>(`/properties?depth=3&limit=10&sort=-updatedAt`);

export const getPost = async (slug: string) =>
	await designGroupCms<{ docs: [] | [Post] }>(`/posts?depth=3&where[slug][equals]=${slug}&limit=1`);

export const getPosts = async () =>
	await designGroupCms<{ docs: [] | [Post] }>(`/posts?depth=3&limit=10&sort=-updatedAt`);

export const getVideos = async () => await cms<{ docs: [] | Video[] }>(`/videos`);

export const getVideo = async (slug: string) =>
	await cms<{ docs: [] | Video[] }>(`/videos?depth=1&where[slug][equals]=${slug}&limit=1`);
